import React from 'react';
import { createContext } from 'react';

import { IJournalEventsFiltersContextValues } from '@features/JournalEventsFilters/model/types';

export const JournalEventsFiltersContext = createContext<IJournalEventsFiltersContextValues>({
    authorsData: [],
    estimatesData: [],
    typesData: [],
    authorsDefaultValues: [],
    estimatesDefaultValues: [],
    typesDefaultValues: [],
    onAuthorClick: () => {},
    onEstimateClick: () => {},
    onTypeClick: () => {},
    onDateClick: () => {},
    onClearAuthorsValues: () => {},
    onClearEstimatesValues: () => {},
    onClearTypesValues: () => {},
    onClearAllValues: () => {},
});

export const JournalEventsFiltersContextProvider = ({
    contextValues,
    children,
}: {
    contextValues: IJournalEventsFiltersContextValues;
    children: React.ReactNode;
}) => (
    <JournalEventsFiltersContext.Provider value={contextValues}>
        {children}
    </JournalEventsFiltersContext.Provider>
);
